import { Button } from '@maui/elements'
import appModalTrigger from './appModalTrigger'

export default appModalTrigger(Button)
